export default "__VITE_ASSET__RX34wZxa__"